import React from 'react';
import { Link } from 'react-router-dom';
import { money, fmtTime } from '../../utils/helpers';
import { isPerUnit } from '../services/useServices';
import ServiceForm from '../services/ServiceForm';
import { useFunctionServices } from './useFunctionServices';

const statusChip = (s) => (s === 'Done' ? 'chip ok' : s === 'Confirmed' ? 'chip male' : s === 'Cancelled' ? 'chip danger' : 'chip pend');

// The catering / event-management panel at the bottom of the Edit Function
// form. It is the Services module scoped to this one function, so the whole
// function - timing, venue, food, manager, money - is planned in one place.
export default function FunctionServicesDesktop({ event, fn }) {
  const { svc, rows, totals, addFor, hasType } = useFunctionServices(event, fn?.FunctionId);
  if (!svc.canView) return null;

  return (
    <div className="fn-services">
      <div className="fn-services-head">
        <strong>Catering &amp; services for this function</strong>
        <span className="muted" style={{ fontSize: 12 }}>
          {rows.length ? `${money(totals.total)} agreed · ${money(totals.advance)} paid · ${money(totals.balance)} balance${totals.units ? ` · ${totals.units} plates/units` : ''}` : 'Nothing booked yet'}
        </span>
        <div className="spacer" />
        {svc.canAdd && <>
          {!hasType('Catering') && <button type="button" className="btn light sm" onClick={() => addFor('Catering', fn)}>+ Catering</button>}
          {!hasType('Event Management') && <button type="button" className="btn light sm" onClick={() => addFor('Event Management', fn)}>+ Event Management</button>}
          <button type="button" className="btn primary sm" onClick={() => addFor('', fn)}>+ Service</button>
        </>}
      </div>

      {rows.length === 0 ? (
        <div className="muted" style={{ fontSize: 12.5, padding: '6px 2px' }}>
          Add the caterer (owner, plates confirmed, charge per plate, advance) and the event manager (company, services, charges, advance). The menu and the job list live inside each service.
        </div>
      ) : (
        <div className="table-wrap">
          <table className="tbl compact">
            <thead>
              <tr>
                <th className="grow">Service</th><th>Company / owner</th><th>Time</th>
                <th>Rate</th><th className="num">Units</th><th className="num">Total</th>
                <th className="num">Paid</th><th className="num">Balance</th><th>Status</th><th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr key={row.ServiceId}>
                  <td className="grow"><strong>{row.ServiceType}</strong>{row.Notes && <div className="sub">{row.Notes}</div>}</td>
                  <td>{row.CompanyName || '—'}<div className="sub">{row.ContactName || row.VendorName || ''}{row.ContactMobile ? ` · ${row.ContactMobile}` : ''}</div></td>
                  <td>{fmtTime(row.StartTime) || '—'}{row.EndTime ? ` – ${fmtTime(row.EndTime)}` : ''}</td>
                  <td>{money(row.Rate)}{isPerUnit(row.RateType) ? ` /${row.RateType === 'PerPlate' ? 'plate' : row.RateType === 'PerDay' ? 'day' : 'hr'}` : ''}</td>
                  <td className="num">{isPerUnit(row.RateType) ? row.ConfirmedCount : '—'}</td>
                  <td className="num">{money(row.TotalAmount)}</td>
                  <td className="num">{money(row.AdvancePaid)}</td>
                  <td className="num"><strong>{money(row.BalanceAmount)}</strong></td>
                  <td><span className={statusChip(row.Status)}>{row.Status}</span></td>
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    {/* Menu of food / list of jobs and the instalments live in the detail page. */}
                    <Link className="btn light sm" to={`/app/services/${row.ServiceId}`}>Menu / jobs</Link>
                    {svc.canEdit && <button type="button" className="icon-btn" title="Edit" onClick={() => svc.openEdit(row)}>✎</button>}
                    {svc.canDelete && <button type="button" className="icon-btn danger" title="Remove" onClick={() => svc.del(row)}>🗑</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {svc.open && <ServiceForm vm={svc} />}
    </div>
  );
}
